import React, { Component } from 'react';
import {Spinner, Row, Col, Button } from 'react-bootstrap';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {ClidReportGenerate, resetReport, ClidReportDownload, closeModalPopUp, WebFormReportInput} from './ReportsActions';
import { connect } from 'react-redux';	
import ShowModalPopUp from '../ShowModalPopUp';
import DatePicker from "react-datepicker";
import moment from "moment";
import ReportView from './ReportView';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import {URL_API_WEB_FORM_GENERATE, URL_API_WEB_FORM_EXCEL} from '../apiHitFile';
import _ from 'lodash';

 class webFormReport extends Component { 
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      selectWebForm:[],
      saveClicked:false,
      GenerateReport:false,
      toggleA:true,
      setreportData:[]
    }
    this.bulkclientName =[]
   }
  componentDidMount(){    
    this.props.actioninventoryUserMapped()
    this.props.resetReport()
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }
  componentWillReceiveProps = (nextProps) => {
    if(!_.isNull(nextProps.reportData) && !_.isEqual(this.props.reportData, nextProps.reportData)){
    this.remakeValues(nextProps.reportData)
    }
  }
  remakeValues = (data) =>{
    if(!_.isEmpty(data) && !_.isEmpty(data.value)){
      let object=[]
      let retundata=_.cloneDeep(data.value)
      if(!_.isEmpty(retundata)){
      _.map(retundata, (obj) => {
        let x = Object.assign(obj,  obj.filledValues)
        _.omit(x, "filledValues")
        object.push(x)
      })
      data.value = object
      this.setState({setreportData:data})      
      } else {
        data.value = []
        this.setState({setreportData:data})
      } 
    } else {
      this.setState({setreportData:data})
    }
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
        let centerName = _.filter(selectedregionName.userCenters);
      return centerName;
    }
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    const{inventory} = this.props;
    let clientName=[];
    if(!_.isEmpty(inventory)){
    _.map(selectedcenterName, (obj)=>{
        let x = _.filter(obj.userClients);
        clientName.push(...x );
        this.bulkclientName=clientName
    }) 
    return _.uniqBy(clientName, 'inventoryClientId');
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    const{inventory} = this.props;
    let processName=[];
    if(!_.isEmpty(inventory)){
    _.map(selectedclientName, (obj)=>{
       let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
      _.map(abc, (z) => {
        processName.push(...z.userProcesses)
        processName = _.uniqBy(processName, 'inventoryProcessId');
      }) 
    })
    }
    return processName;
  }  
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], selectWebForm:[], GenerateReport:false})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[], selectWebForm:[], GenerateReport:false})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[], selectWebForm:[], GenerateReport:false})
    }
  }
  handleSelectProcess = (e) => {
    const {selectedregionName, selectedcenterName, selectedclientName} = this.state
    this.setState({selectedprocessName: e});  
    if(!_.isEqual(this.state.selectedprocessName, e)){
      this.setState({selectWebForm:[], GenerateReport:false})
    }
    if(typeof e !== "undefined"){
      let input = {
        "region":selectedregionName.inventoryRegionId,
        "center": _.map(selectedcenterName, (cx) => { return(cx.inventoryCenterId)}),
        "client": _.map(selectedclientName, (cx) => { return(cx.inventoryClientId)}),
        "process": _.map(e, (cx) => { return(cx.inventoryProcessId)}),
        }
        this.props.TokenValidation()
        this.props.WebFormReportInput(input)
    }
  }
  handleSelectWebForm = (e) => {
    this.setState({selectWebForm: e});  
    if(!_.isEqual(this.state.selectWebForm, e)){
      this.setState({GenerateReport:false})
    }
   
  }
  handleChangeStart = (date) => {
    this.setState({startDate: date});
  }
  validateInput = () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate, selectWebForm} = this.state
    if(!_.isEmpty(selectedregionName) && !_.isEmpty(selectedcenterName) && !_.isEmpty(selectedprocessName) &&
    !_.isEmpty(selectWebForm) && !_.isEmpty(selectedclientName) && typeof startDate !== "undefined"){
      return true
    }
  }  
  generateReport = () => {
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate, selectWebForm} = this.state
    let obj = {
      "region":selectedregionName.inventoryRegionId,
      "center": _.map(selectedcenterName, (cx) => { return(cx.inventoryCenterId)}),
      "client": _.map(selectedclientName, (cx) => { return(cx.inventoryClientId)}),
      "process": _.map(selectedprocessName, (cx) => { return(cx.inventoryProcessId)}),
      "month":moment(startDate).format('MMM'),
      "year":moment(startDate).format('YYYY'),
      "webFormId":!_.isEmpty(selectWebForm) ? selectWebForm.id : ''
      }
    this.props.TokenValidation()
    this.props.ClidReportGenerate(obj, URL_API_WEB_FORM_GENERATE)
    this.setState({GenerateReport:true})
  }
  handleToggle = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  downloadReport= () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate, selectWebForm} = this.state
    let obj = {
      "region":selectedregionName.inventoryRegionId,
      "center": _.map(selectedcenterName, (cx) => { return(cx.inventoryCenterId)}),
      "client": _.map(selectedclientName, (cx) => { return(cx.inventoryClientId)}),
      "process": _.map(selectedprocessName, (cx) => { return(cx.inventoryProcessId)}),
      "month":moment(startDate).format('MMM'),
      "year":moment(startDate).format('YYYY'),
      "webFormId":!_.isEmpty(selectWebForm) ? selectWebForm.id : ''
      }
     this.props.TokenValidation()
     this.props.ClidReportDownload(obj, URL_API_WEB_FORM_EXCEL, "WEB_FORM_REPORT.xlsx")
   }

	render(){
    const {GenerateReport, toggleA} = this.state;    
		let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }		
		return(
			<div  className={(style) ? 'user' : "userSmall"}>			
				{(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
        <div>
          <h6 onClick={this.handleToggle} >
          {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>&nbsp;REPORT CRITERIA</b></h6>  
        <div className={toggleA ? '': 'assesmentHide'}>  
          <Row className="marginBottom">  
          <Col>
          <label><b>REGION NAME<span className="RedColoring"> *</span></b></label><br/>
          <Picky keepOpen={false}
          value={this.state.selectedregionName}
          options={this.regionNames()}
          onChange={this.handleSelect}
          open={false}
          valueKey="inventoryRegionName"
          labelKey="inventoryRegionName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={false}
          placeholder='Select Region'
          dropdownHeight={600}
          />
          </Col>
          <Col>
          <label><b>CENTER NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedcenterName}
          options={this.centerNames()}
          onChange={this.handleSelectCenter}
          open={false}
          valueKey="inventoryCenterName"
          labelKey="inventoryCenterName"
          multiple={true}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Center'
          dropdownHeight={600}
          />
          </Col>
          <Col>
          <label><b>CLIENT NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedclientName}
          options={this.clientNames()}
          onChange={this.handleSelectClient}
          open={false}
          valueKey="inventoryClientName"
          labelKey="inventoryClientName"
          multiple={true}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Client'
          dropdownHeight={600}
          />
          </Col>   
          <Col>
          <label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedprocessName}
          options={this.processNames()}
          onChange={this.handleSelectProcess}
          open={false}
          valueKey="inventoryProcessName"
          labelKey="inventoryProcessName"
          multiple={true}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Process'
          dropdownHeight={600}
          />
          </Col> 
         <Col>
          <label><b>WEB FORM NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectWebForm}
          options={!_.isEmpty(this.props.webFormNames) ? this.props.webFormNames : []}
          onChange={this.handleSelectWebForm}
          open={false}
          valueKey="name"
          labelKey="name"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Web Form'
          dropdownHeight={600}
          />
          {(_.isEmpty(this.props.webFormNames) && !_.isEmpty(this.state.selectedprocessName)) ?  
          <span className="RedColoring"> No web Form Mapped </span>: null}
          </Col>         
          <Col>
          <label><b>DATE<span className="RedColoring"> *</span></b></label>
          <DatePicker
          selected={this.state.startDate}
          onChange={this.handleChangeStart}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          placeholderText="Select Month/Year"
          popperModifiers={{
            preventOverflow: {
              enabled: true,
              escapeWithReference: false, 
              boundariesElement: 'viewport'
            }
          }}
          />
          </Col> 
          </Row> 
       </div>
          <Button className='buttonwidth alignInline alignRight' disabled={!this.validateInput()}
          onClick={this.generateReport}>Generate Report</Button>
          {((GenerateReport === true) && !_.isEmpty(this.props.reportData)  && !_.isEmpty(this.state.setreportData.value)) ? 
          <Button className='buttonwidth alignInline alignRight' onClick={this.downloadReport}>Download Report</Button> : null}
          {((GenerateReport === true) && !_.isEmpty(this.state.setreportData)) ?
           <ReportView  reportData={this.state.setreportData} />
          : null }
        </div> 
			</div>)
	}

}
function mapStateToProps(state){  
  return{
    size: state.UserReducer.large,    
    inventory: state.UserReducer.inventoryMapped, 
    reportData: state.ReportsReducer.reportData, 
    webFormNames: state.ReportsReducer.webFormNames, 
    isPending: state.ReportsReducer.isPending,
    showerror:  state.ReportsReducer.showerror, 
    errmessage:  state.ReportsReducer.errmessage,
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  WebFormReportInput:  (obj) =>dispatch(WebFormReportInput(obj)),
  ClidReportGenerate: (a, b) => dispatch(ClidReportGenerate(a,b)),
  ClidReportDownload: (a, b, c) => dispatch(ClidReportDownload(a, b, c)),
  resetReport: () => dispatch(resetReport()),
  TokenValidation : () => dispatch(TokenValidation()),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  
})


export default connect(mapStateToProps, mapDispatchToProps)(webFormReport);     